import { useState,useMemo } from 'react';
import { Skeleton, Table, TableBody, TableHead, TableRow, Paper, TableCell, TableContainer, TablePagination, TableSortLabel, Box, TextField, Divider, Typography, Tooltip} from '@mui/material';

import styles from './Table.module.scss'
import CompanyDataCell from '../screnner/components/CompanyDataCell';
import { ErrorOutline } from '@mui/icons-material';

export default function CustomTable({ columns, rows, Theader, showLoader, rowsPerPage = -1 }) {
  const [page, setPage] = useState(0);
  const [rowsPerPageValue, setRowsPerPageValue] = useState(10);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const [searchText, setSearchText] = useState('');

  const handleRequestSort = (property) => {
    const isAscending = orderBy === property && order === 'asc';
    setOrder(isAscending ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const totalWidth = useMemo(() => {
    const width = columns.reduce((acc, column) => {
      const widthValue = parseInt(column.Width, 10) || 180; // Default width if not provided
      return acc + widthValue;
    }, 0);
    if (width<Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)){
      return '100%'; // If total width is less than 1440px, set the width to 1440px to ensure table is fully visible
    }
    return width
  }, [columns]);

  const handleChangePage = (e, pageIndex) => setPage(pageIndex);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPageValue(+event.target.value);
    setPage(0);
  };

  

  const filteredRows = useMemo(() => {
    if (!searchText) return rows;
    return rows.filter((row) =>
      columns.some((column) => {
        const value = row[column.id];
        return value && value.toString().toLowerCase().includes(searchText.toLowerCase());
      })
    );
  }, [rows, searchText, columns]);

  const sortedRows = useMemo(() => {
    if (!orderBy) return filteredRows;
    return [...filteredRows].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === 'asc' ? -1 : 1;
      if (aValue > bValue) return order === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredRows, orderBy, order]);

  // const sortedRows = useMemo(() => {
  //   if (!orderBy) return rows;
  //   return [...rows].sort((a, b) => {
  //     const aValue = a[orderBy];
  //     const bValue = b[orderBy];
  //     if (aValue < bValue) return order === 'asc' ? -1 : 1;
  //     if (aValue > bValue) return order === 'asc' ? 1 : -1;
  //     return 0;
  //   });
  // }, [rows, orderBy, order]);
  
  
  return (
    <Paper sx={{ overflow: 'hidden' }}>
      <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            // justifyContent: 'space-between',
            // marginBottom: '16px',
            padding:'10px'
          }}
        >
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ width: '200px',border:'1px solid yellow',borderRadius:'7.5px' }}
          />
        </Box>
        <Divider />
      {rows?.length ? (
        <>
          <TableContainer >
            <Table stickyHeader aria-label="sticky table" style={{width:totalWidth}}>
              <TableHead classes={{root:styles['root-header']}}>
                {rows.length>0&&Theader == true&&<TableRow classes={{root:styles['root-header']}}>
                  <TableCell align="center" colSpan={2} classes={{root:styles['root-header']}}>
                    Company Details
                  </TableCell>
                  <TableCell align="center" colSpan={columns.length - 2} classes={{root:styles['root-header']}}>
                    Correlation Data
                  </TableCell>
                </TableRow>}
                <TableRow classes={{root:styles['root-header']}}>
                  {columns.map((column) => (
                    <TableCell
                      classes={{root:styles['root-header']}}
                      key={`head-${column.id}`}
                      // sx={{ whiteSpace: 'nowrap'}}
                      align="center"
                      sortDirection={orderBy === column.id ? order : false}
                      style={{ minWidth: column.minWidth }}// Ensure a minimum width for each column
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : 'asc'}
                        onClick={() => handleRequestSort(column.id)}
                      >
                        {column.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* {rows
                  // .filter((_, index) =>
                  //   rowsPerPage !== -1
                  //     ? page * rowsPerPage <= index && index < page * rowsPerPage + rowsPerPage
                  //     : true
                  // )
                  .slice(page * rowsPerPageValue, page * rowsPerPageValue + rowsPerPageValue) */}
                {sortedRows
                  .filter((_, index) =>
                    rowsPerPageValue !== -1
                      ? page * rowsPerPageValue <= index && index < page * rowsPerPageValue + rowsPerPageValue
                      : true
                  )
                  .map((row, index) => {
                    return (
                      <TableRow key={`table-row-${index}`} classes={{root:styles['root-row']}}>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={`table-cell-${column.id}-${index}`}
                              align="center"
                              // sx={{ whiteSpace: 'nowrap'}} // Prevents text from wrapping
                              style={{ minWidth: column.minWidth }}
                            >
                              {column.id === 'name' ? ( // Replace 'name' with the column id you want to check
                                  <CompanyDataCell
                                    ticker={row.value} // Replace 'value' with the correct key for ticker
                                    companyName={row.name} // Replace 'name' with the correct key for the company name
                                  />
                                )
                                : column.format && typeof row[column.id] === "number"
                                ? <Tooltip placement="top-start" arrow title={`Number of data Points: ${row.number_of_observations}`}>{row[column.id]}%</Tooltip>
                                : row[column.id]}
                              {/* {column.format && typeof value === column.type
                                ? column.format(value)
                                : value} */}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10,20,50,100]}
              component="div"
              count={sortedRows.length}
              rowsPerPage={rowsPerPageValue}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </>
      ) : (
        showLoader?<Typography style={{display:'flex',justifyContent:'center',margin:'50px 0px',padding:'20px'}}>No Data Found! Please Add the filetrs</Typography>:<Skeleton variant="rect" width="100%" height={150} />
      )}
    </Paper>
  );
}
